(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-lyss-image-controls]').forEach(component => {
      if (component.lyssControlsObserver) return;
      const media = component.querySelector('.slideshow__media');
      const controls = component.querySelector('.slideshow__controls');
      if (!media || !controls) return;
      const position = () => {
        const box = media.getBoundingClientRect();
        if (!box.height) return;
        component.style.setProperty('--lyss-controls-top', Math.max(0, box.bottom - component.getBoundingClientRect().top - 56) + 'px');
        component.setAttribute('data-lyss-controls-ready', '');
      };
      const observer = new ResizeObserver(position);
      observer.observe(media);
      observer.observe(component);
      component.lyssControlsObserver = observer;
      position();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-lyss-image-controls]').forEach(component => component.lyssControlsObserver?.disconnect()));
})();
